module.exports = __webpack_public_path__ + "static/media/fly0268.668caf79.webp";